/**
 * RdSAP API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RdSAPResultsDetailUIDTOV0 } from './rdSAPResultsDetailUIDTOV0';
import { RdSAPBuildingPartUIDTOV0 } from './rdSAPBuildingPartUIDTOV0';
import { RdSAPOpeningDetailUIDTOV0 } from './rdSAPOpeningDetailUIDTOV0';
import { RdSAPGeneralDetailUIDTOV0 } from './rdSAPGeneralDetailUIDTOV0';
import { RdSAPRenewablesRecoveryUIDTOV0 } from './rdSAPRenewablesRecoveryUIDTOV0';
import { RdSAPSurveyDetailsDtoUIDTOV0 } from './rdSAPSurveyDetailsDtoUIDTOV0';
import { SAPSpecialFeatureUIDTOV0 } from './sAPSpecialFeatureUIDTOV0';
import { RdSAPHeatingUIDTOV0 } from './rdSAPHeatingUIDTOV0';


export interface RdSAPAssessmentReportUIDTOV0 { 
    generic: RdSAPSurveyDetailsDtoUIDTOV0;
    results?: RdSAPResultsDetailUIDTOV0;
    general: RdSAPGeneralDetailUIDTOV0;
    opening?: RdSAPOpeningDetailUIDTOV0;
    heating?: RdSAPHeatingUIDTOV0;
    renewables?: RdSAPRenewablesRecoveryUIDTOV0;
    buildingParts?: Array<RdSAPBuildingPartUIDTOV0>;
    sapSpecialFeatures?: Array<SAPSpecialFeatureUIDTOV0>;
}

